import { useState } from 'react';
import { IRegisterPayload } from '../../types/authentication';
import { authenticationServices } from '../../services/authentication.service';
import _ from 'lodash';
import toast from 'react-hot-toast';

export const useRegister = (onRegisterSuccess: () => void) => {
  const [loading, setLoading] = useState<boolean>(false);

  const handleRegister = async (payload: IRegisterPayload) => {
    try {
      setLoading(true);
      await authenticationServices.register(payload);
      onRegisterSuccess();
    } catch (error) {
      //
      const message = _.get(error, 'response.data.detail');
      toast.error(message || 'Đăng ký thất bại');
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    handleRegister,
  };
};
